import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { ArticleDto } from 'src/app/shared/dto/article.dto';
import { inject } from '@angular/core';

@Component({
    selector: 'app-modal-select-alternative-article',
    standalone: true,
    imports: [
        CommonModule,
        NzButtonModule,
        NzSelectModule,
        FormsModule
    ],
    template: `
        <div class="p-4">
            <p class="mb-4 text-gray-700">
                Seleccione el artículo alternativo con el que desea sustituir la materia prima actual:
            </p>

            <div class="mb-6">
                <nz-select
                    [(ngModel)]="selectedArticleId"
                    nzPlaceHolder="Seleccione un artículo"
                    nzShowSearch
                    class="w-full"
                    [nzSize]="'large'">
                    @for (article of articles; track article.id) {
                        <nz-option
                            [nzValue]="article.id"
                            [nzLabel]="article.name || ''">
                        </nz-option>
                    }
                </nz-select>
            </div>

            <div class="flex justify-end gap-2 mt-6">
                <button
                    nz-button
                    nzType="default"
                    (click)="handleCancel()">
                    Cancelar
                </button>
                <button
                    nz-button
                    nzType="primary"
                    [disabled]="!selectedArticleId"
                    (click)="handleOk()">
                    Aceptar
                </button>
            </div>
        </div>
    `
})
export class ModalSelectAlternativeArticleComponent implements OnInit {
    private modalRef = inject(NzModalRef);
    readonly data: {
        alternativeArticles: any[];
        currentArticle: ArticleDto;
    } = inject(NZ_MODAL_DATA);

    alternativeArticles: ArticleDto[] = [];
    selectedArticleId?: number;
    articles: ArticleDto[] = [];

    ngOnInit(): void {
        this.articles = this.data.alternativeArticles;
    }

    handleOk(): void {
        if (this.selectedArticleId) {
            const selectedArticle = this.articles.find(
                article => article.id === this.selectedArticleId
            );
            this.modalRef.close(selectedArticle);
        }
    }

    handleCancel(): void {
        this.modalRef.close(null);
    }
}
